import { Component } from '@angular/core';
import { FiDialogsContentBase } from '../../../fi-dialogs/fi-dialogs-content-base';

export interface IAdvancedTextPanelPasteDialogData {
    messageText: string;
}

@Component({
    selector: 'fi-advanced-text-panel-paste-dialog',
    templateUrl: './advanced-text-panel-paste-dialog.component.html',
    styleUrls: ['./advanced-text-panel-paste-dialog.component.scss'],
    standalone: false,
})
export class AdvancedTextPanelPasteDialogComponent extends FiDialogsContentBase<
    IAdvancedTextPanelPasteDialogData,
    string
> {
    resultValue = {
        input: '',
    };

    isYesButtonDisabled() {
        return this.resultValue.input === '';
    }

    getResult() {
        return this.resultValue.input;
    }
}
